import * as duckdb from '@duckdb/duckdb-wasm';
import mvp_worker from '@duckdb/duckdb-wasm/dist/duckdb-browser-mvp.worker.js?url';
import eh_worker from '@duckdb/duckdb-wasm/dist/duckdb-browser-eh.worker.js?url';

// EOS signal for Arrow IPC streaming format
import type { CompiledQuery } from 'kysely';

export const EOS = new Uint8Array([255, 255, 255, 255, 0, 0, 0, 0]);

const MANUAL_BUNDLES: duckdb.DuckDBBundles = {
  mvp: {
    mainModule: 'https://cdn.jsdelivr.net/npm/@duckdb/duckdb-wasm@1.29.0/dist/duckdb-mvp.wasm',
    mainWorker: mvp_worker,
  },
  eh: {
    mainModule: 'https://cdn.jsdelivr.net/npm/@duckdb/duckdb-wasm@1.29.0/dist/duckdb-eh.wasm',
    mainWorker: eh_worker,
  },
};
// Select a bundle based on browser checks
const bundle = await duckdb.selectBundle(MANUAL_BUNDLES);
// Instantiate the asynchronus version of DuckDB-wasm
const worker = new Worker(bundle.mainWorker!);
const logger = new duckdb.ConsoleLogger();
export const duckDB = new duckdb.AsyncDuckDB(logger, worker);
await duckDB.instantiate(bundle.mainModule, bundle.pthreadWorker);

export const connection = await duckDB.connect();

export async function executeCompiledQuery(query: CompiledQuery, connection: duckdb.AsyncDuckDBConnection) {
  const q = await connection.prepare(query.sql);
  const result = await q.query(...query.parameters);
  return result;
}
